import React from 'react';
import PropTypes from 'prop-types';

export const MapIcon = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.087 6.348V20.26m6.087-9.565V2m-.87 14.534L8.087 20.26 2 15.913V2l6.087 4.348L14.174 2l6.087 4.348v4.348"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 15.913C22 17.835 18.522 22 18.522 22s-3.478-4.165-3.478-6.087a3.478 3.478 0 1 1 6.956 0v0Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.826 15.913a1.304 1.304 0 1 1-2.609 0 1.304 1.304 0 0 1 2.61 0Z"
      clipRule="evenodd"
    />
  </svg>
);

MapIcon.propTypes = {
  color: PropTypes.string
};
